// extracted by mini-css-extract-plugin
export default {"separatorHorizontal":"Separator_separatorHorizontal__s7ICY","separatorVertical":"Separator_separatorVertical__C23q4"};